import { FunctionComponent } from "react";

// eslint-disable-next-line no-restricted-imports
import { ProgressIndicator } from "@fluentui/react";

export const Loading: FunctionComponent = () => {
  return (
    <ProgressIndicator
      label="Loading Form"
      description="Loading Form. Please wait."
    />
  );
};
